export default __webpack_public_path__ + "static/media/as.b653fa66.jpg";